import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Navbar from 'react-bootstrap/Navbar';

const StyledNavBar = styled(Navbar)`
  padding: 5px 20px 5px 20px;
  margin: 0;
  height: 5rem;
`;

const NavBarBanner = (props) => {
  const {
    children,
    background,
    id,
    className,
  } = props;

  return (
    <StyledNavBar bg={background} id={id} className={className}>
      {children}
    </StyledNavBar>
  );
};

NavBarBanner.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node]),
  background: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
};

NavBarBanner.defaultProps = {
  children: '',
  className: '',
};

export default NavBarBanner;
